/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TicketScannerRouteImport } from './routes/ticket/scanner'
import { Route as TicketTicketIdRouteImport } from './routes/ticket/$ticketId'
import { Route as OrgOrgIdIndexRouteImport } from './routes/org/$orgId/index'
import { Route as UserIdQuizRouteImport } from './routes/user/$id/quiz'
import { Route as OrgOrgIdPreviewRouteImport } from './routes/org/$orgId/preview'
import { Route as OrgOrgIdEditIndexRouteImport } from './routes/org/$orgId/edit/index'
import { Route as OrgOrgIdEventCreateRouteImport } from './routes/org/$orgId/event/create'
import { Route as OrgOrgIdEventEventIdRouteImport } from './routes/org/$orgId/event/$eventId'

const QrLazyRouteImport = createFileRoute('/qr')()
const AboutUsLazyRouteImport = createFileRoute('/about-us')()
const IndexLazyRouteImport = createFileRoute('/')()
const HomeIndexLazyRouteImport = createFileRoute('/home/')()
const UserIdWalletLazyRouteImport = createFileRoute('/user/$id/wallet')()
const UserIdProfileLazyRouteImport = createFileRoute('/user/$id/profile')()

const QrLazyRoute = QrLazyRouteImport.update({
  id: '/qr',
  path: '/qr',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/qr.lazy').then((d) => d.Route))
const AboutUsLazyRoute = AboutUsLazyRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about-us.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const HomeIndexLazyRoute = HomeIndexLazyRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/home/index.lazy').then((d) => d.Route))
const TicketScannerRoute = TicketScannerRouteImport.update({
  id: '/ticket/scanner',
  path: '/ticket/scanner',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketTicketIdRoute = TicketTicketIdRouteImport.update({
  id: '/ticket/$ticketId',
  path: '/ticket/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgIdIndexRoute = OrgOrgIdIndexRouteImport.update({
  id: '/org/$orgId/',
  path: '/org/$orgId/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserIdWalletLazyRoute = UserIdWalletLazyRouteImport.update({
  id: '/user/$id/wallet',
  path: '/user/$id/wallet',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/user/$id/wallet.lazy').then((d) => d.Route),
)
const UserIdProfileLazyRoute = UserIdProfileLazyRouteImport.update({
  id: '/user/$id/profile',
  path: '/user/$id/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/user/$id/profile.lazy').then((d) => d.Route),
)
const UserIdQuizRoute = UserIdQuizRouteImport.update({
  id: '/user/$id/quiz',
  path: '/user/$id/quiz',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgIdPreviewRoute = OrgOrgIdPreviewRouteImport.update({
  id: '/org/$orgId/preview',
  path: '/org/$orgId/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgIdEditIndexRoute = OrgOrgIdEditIndexRouteImport.update({
  id: '/org/$orgId/edit/',
  path: '/org/$orgId/edit/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgIdEventCreateRoute = OrgOrgIdEventCreateRouteImport.update({
  id: '/org/$orgId/event/create',
  path: '/org/$orgId/event/create',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgIdEventEventIdRoute = OrgOrgIdEventEventIdRouteImport.update({
  id: '/org/$orgId/event/$eventId',
  path: '/org/$orgId/event/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/about-us': typeof AboutUsLazyRoute
  '/qr': typeof QrLazyRoute
  '/ticket/$ticketId': typeof TicketTicketIdRoute
  '/ticket/scanner': typeof TicketScannerRoute
  '/home': typeof HomeIndexLazyRoute
  '/org/$orgId/preview': typeof OrgOrgIdPreviewRoute
  '/user/$id/quiz': typeof UserIdQuizRoute
  '/user/$id/profile': typeof UserIdProfileLazyRoute
  '/user/$id/wallet': typeof UserIdWalletLazyRoute
  '/org/$orgId': typeof OrgOrgIdIndexRoute
  '/org/$orgId/event/$eventId': typeof OrgOrgIdEventEventIdRoute
  '/org/$orgId/event/create': typeof OrgOrgIdEventCreateRoute
  '/org/$orgId/edit': typeof OrgOrgIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/about-us': typeof AboutUsLazyRoute
  '/qr': typeof QrLazyRoute
  '/ticket/$ticketId': typeof TicketTicketIdRoute
  '/ticket/scanner': typeof TicketScannerRoute
  '/home': typeof HomeIndexLazyRoute
  '/org/$orgId/preview': typeof OrgOrgIdPreviewRoute
  '/user/$id/quiz': typeof UserIdQuizRoute
  '/user/$id/profile': typeof UserIdProfileLazyRoute
  '/user/$id/wallet': typeof UserIdWalletLazyRoute
  '/org/$orgId': typeof OrgOrgIdIndexRoute
  '/org/$orgId/event/$eventId': typeof OrgOrgIdEventEventIdRoute
  '/org/$orgId/event/create': typeof OrgOrgIdEventCreateRoute
  '/org/$orgId/edit': typeof OrgOrgIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/about-us': typeof AboutUsLazyRoute
  '/qr': typeof QrLazyRoute
  '/ticket/$ticketId': typeof TicketTicketIdRoute
  '/ticket/scanner': typeof TicketScannerRoute
  '/home/': typeof HomeIndexLazyRoute
  '/org/$orgId/preview': typeof OrgOrgIdPreviewRoute
  '/user/$id/quiz': typeof UserIdQuizRoute
  '/user/$id/profile': typeof UserIdProfileLazyRoute
  '/user/$id/wallet': typeof UserIdWalletLazyRoute
  '/org/$orgId/': typeof OrgOrgIdIndexRoute
  '/org/$orgId/event/$eventId': typeof OrgOrgIdEventEventIdRoute
  '/org/$orgId/event/create': typeof OrgOrgIdEventCreateRoute
  '/org/$orgId/edit/': typeof OrgOrgIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about-us'
    | '/qr'
    | '/ticket/$ticketId'
    | '/ticket/scanner'
    | '/home'
    | '/org/$orgId/preview'
    | '/user/$id/quiz'
    | '/user/$id/profile'
    | '/user/$id/wallet'
    | '/org/$orgId'
    | '/org/$orgId/event/$eventId'
    | '/org/$orgId/event/create'
    | '/org/$orgId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about-us'
    | '/qr'
    | '/ticket/$ticketId'
    | '/ticket/scanner'
    | '/home'
    | '/org/$orgId/preview'
    | '/user/$id/quiz'
    | '/user/$id/profile'
    | '/user/$id/wallet'
    | '/org/$orgId'
    | '/org/$orgId/event/$eventId'
    | '/org/$orgId/event/create'
    | '/org/$orgId/edit'
  id:
    | '__root__'
    | '/'
    | '/about-us'
    | '/qr'
    | '/ticket/$ticketId'
    | '/ticket/scanner'
    | '/home/'
    | '/org/$orgId/preview'
    | '/user/$id/quiz'
    | '/user/$id/profile'
    | '/user/$id/wallet'
    | '/org/$orgId/'
    | '/org/$orgId/event/$eventId'
    | '/org/$orgId/event/create'
    | '/org/$orgId/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AboutUsLazyRoute: typeof AboutUsLazyRoute
  QrLazyRoute: typeof QrLazyRoute
  TicketTicketIdRoute: typeof TicketTicketIdRoute
  TicketScannerRoute: typeof TicketScannerRoute
  HomeIndexLazyRoute: typeof HomeIndexLazyRoute
  OrgOrgIdPreviewRoute: typeof OrgOrgIdPreviewRoute
  UserIdQuizRoute: typeof UserIdQuizRoute
  UserIdProfileLazyRoute: typeof UserIdProfileLazyRoute
  UserIdWalletLazyRoute: typeof UserIdWalletLazyRoute
  OrgOrgIdIndexRoute: typeof OrgOrgIdIndexRoute
  OrgOrgIdEventEventIdRoute: typeof OrgOrgIdEventEventIdRoute
  OrgOrgIdEventCreateRoute: typeof OrgOrgIdEventCreateRoute
  OrgOrgIdEditIndexRoute: typeof OrgOrgIdEditIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/qr': {
      id: '/qr'
      path: '/qr'
      fullPath: '/qr'
      preLoaderRoute: typeof QrLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/': {
      id: '/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ticket/scanner': {
      id: '/ticket/scanner'
      path: '/ticket/scanner'
      fullPath: '/ticket/scanner'
      preLoaderRoute: typeof TicketScannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ticket/$ticketId': {
      id: '/ticket/$ticketId'
      path: '/ticket/$ticketId'
      fullPath: '/ticket/$ticketId'
      preLoaderRoute: typeof TicketTicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgId/': {
      id: '/org/$orgId/'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof OrgOrgIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$id/wallet': {
      id: '/user/$id/wallet'
      path: '/user/$id/wallet'
      fullPath: '/user/$id/wallet'
      preLoaderRoute: typeof UserIdWalletLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$id/profile': {
      id: '/user/$id/profile'
      path: '/user/$id/profile'
      fullPath: '/user/$id/profile'
      preLoaderRoute: typeof UserIdProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$id/quiz': {
      id: '/user/$id/quiz'
      path: '/user/$id/quiz'
      fullPath: '/user/$id/quiz'
      preLoaderRoute: typeof UserIdQuizRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgId/preview': {
      id: '/org/$orgId/preview'
      path: '/org/$orgId/preview'
      fullPath: '/org/$orgId/preview'
      preLoaderRoute: typeof OrgOrgIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgId/edit/': {
      id: '/org/$orgId/edit/'
      path: '/org/$orgId/edit'
      fullPath: '/org/$orgId/edit'
      preLoaderRoute: typeof OrgOrgIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgId/event/create': {
      id: '/org/$orgId/event/create'
      path: '/org/$orgId/event/create'
      fullPath: '/org/$orgId/event/create'
      preLoaderRoute: typeof OrgOrgIdEventCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgId/event/$eventId': {
      id: '/org/$orgId/event/$eventId'
      path: '/org/$orgId/event/$eventId'
      fullPath: '/org/$orgId/event/$eventId'
      preLoaderRoute: typeof OrgOrgIdEventEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AboutUsLazyRoute: AboutUsLazyRoute,
  QrLazyRoute: QrLazyRoute,
  TicketTicketIdRoute: TicketTicketIdRoute,
  TicketScannerRoute: TicketScannerRoute,
  HomeIndexLazyRoute: HomeIndexLazyRoute,
  OrgOrgIdPreviewRoute: OrgOrgIdPreviewRoute,
  UserIdQuizRoute: UserIdQuizRoute,
  UserIdProfileLazyRoute: UserIdProfileLazyRoute,
  UserIdWalletLazyRoute: UserIdWalletLazyRoute,
  OrgOrgIdIndexRoute: OrgOrgIdIndexRoute,
  OrgOrgIdEventEventIdRoute: OrgOrgIdEventEventIdRoute,
  OrgOrgIdEventCreateRoute: OrgOrgIdEventCreateRoute,
  OrgOrgIdEditIndexRoute: OrgOrgIdEditIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
